import "./Shopping.css";
import { useAxiosAuth } from "../../hooks";
import { useEffect, useState } from "react";
import { NormalLink } from "../../components/buttons";
import {
  changeLayout,
  changeInfo,
  openSnackbar,
  startSession,
  changeModal,
} from "../../store/actions";
import { connect } from "react-redux";
import { getAction } from "../../services/action/Action";
import { validateArray, validateStatus } from "../../utils/Validation";
import ShoppingAside from "../../containers/shopping/ShoppingAside";
import { H2, H3, H4 } from "../../components/text";
import { LoadCircle } from "../../components/animation";
import { IconAction } from "../../components/buttonsIcon";
import { UseOnSubmit } from "../../hooks/useOnSubmit";
import { putAction } from "../../services/action/Action";
import { GlobalForm } from "../../components/form";
import { InputsCoupon } from "../../utils/FormParameters";
const Shopping = (props) => {
  const { changeLayout, changeInfo } = props;
  const { response, loading, reload } = useAxiosAuth({
    method: "GET",
    url: window.localStorage.getItem("id") ? "/Shoppingcart" : "",
  });
  const [shopping, setshopping] = useState([]);
  const [chosenPlan, setchosenPlan] = useState({});
  const [handleCoupon, sethandleCoupon] = useState(null);
  function getShopping() {
    if (window.localStorage.getItem("id")) {
      return response ? response : [];
    } else {
      const storageShop = window.localStorage.getItem("shopping")
        ? JSON.parse(window.localStorage.getItem("shopping"))
        : [] || [];

      return storageShop;
    }
  }
  function reloadShopping() {
    reload();
    const listShop = getShopping();
    setshopping(listShop);
    setchosenPlan({});
    let aux = {};
    listShop.forEach((item) => {
      if (chosenPlan[item.programManagerId]) {
        aux = {
          ...aux,
          [item.programManagerId]: chosenPlan[item.programManagerId],
        };
      } else {
        getAction(`/paymentplan/plans/${item.programManagerId}`).then((res) => {
          if (res && validateStatus(res.status) && validateArray(res.data)) {
            const isMain = res.data.filter((p) => p.isMain);
            if (validateArray(isMain)) {
              setchosenPlan((a) => ({
                ...a,
                [item.programManagerId]: isMain[0],
              }));
            } else {
              setchosenPlan((a) => ({
                ...a,
                [item.programManagerId]: res.data[0],
              }));
            }
          }
        });
      }
    });
  }
  useEffect(() => {
    function handlePlan(listShop) {
      let aux = {};
      listShop.forEach((item) => {
        if (chosenPlan[item.programManagerId]) {
          aux = {
            ...aux,
            [item.programManagerId]: chosenPlan[item.programManagerId],
          };
        } else {
          getAction(`/paymentplan/plans/${item.programManagerId}`).then(
            (res) => {
              if (
                res &&
                validateStatus(res.status) &&
                validateArray(res.data)
              ) {
                const isMain = res.data.filter((p) => p.isMain);
                if (validateArray(isMain)) {
                  setchosenPlan((a) => ({
                    ...a,
                    [item.programManagerId]: isMain[0],
                  }));
                } else {
                  setchosenPlan((a) => ({
                    ...a,
                    [item.programManagerId]: res.data[0],
                  }));
                }
              }
            }
          );
        }
      });
    }
    const listShop = getShopping();
    setshopping(listShop);
    handlePlan(listShop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response, window.localStorage.getItem("shopping")]);

  useEffect(() => {
    changeLayout();
    changeInfo(
      <ShoppingAside
        {...props}
        chosenPlan={{ ...chosenPlan }}
        handleCoupon={handleCoupon}
        shopping={shopping}
      />
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeLayout, changeInfo, chosenPlan, handleCoupon, shopping]);

  return (
    <>
      <br />
      <H2>Pedidos</H2>
      {loading ? (
        <LoadCircle />
      ) : validateArray(shopping) ? (
        <>
          {shopping.map((program) => (
            <CourseShop
              {...props}
              program={program}
              shopping={shopping}
              key={program.programManagerId}
              reloadShopping={reloadShopping}
              chosenPlan={chosenPlan[program.programManagerId]}
            />
          ))}
          {handleCoupon && <H4>Cupón aplicado: {handleCoupon.code}</H4>}
          <RenderCoupon
            shopping={shopping}
            sethandleCoupon={sethandleCoupon}
            {...props}
          />
        </>
      ) : (
        <>
          <H3>No tienes cursos en el carrito</H3>
          <center>
            <NormalLink to="/catalogue/short-courses/4">Ver cursos</NormalLink>
          </center>
        </>
      )}
    </>
  );
};
function CourseShop(props) {
  const { program, reloadShopping, openSnackbar, shopping, chosenPlan } = props;
  async function handleRemove() {
    if (window.localStorage.getItem("id")) {
      await UseOnSubmit({
        axiosParams: {
          method: "DELETE",
          url: `/Shoppingcart/${program.id}`,
        },
        openSnackbar: openSnackbar,
        textSuccess: "Se elimino del carrito",
        textWrong: "No se pudo eliminar",
      });
    } else {
      const shoppingList = shopping.filter(
        (f) => f.programManagerId !== program.programManagerId
      );
      window.localStorage.setItem(
        "shopping",
        JSON.stringify([...shoppingList])
      );
      openSnackbar("Se elimino del carrito", true, true);
    }
    reloadShopping();
  }
  return (
    <div className="CourseShop">
      <div className="CourseShop__container">
        <div className="CourseShop__title">
          <H4>Curso</H4>
          <H4 fontWeight="600">
            {program.name ? program.name : program.programManagerName}
          </H4>
        </div>
        {/* <div className="CourseShop__item">
          <H4>Nro de pagos</H4>
          <H4 fontWeight="600">
            {chosenPlan?.partialAmounts
              ? chosenPlan?.partialAmounts.length > 0
                ? chosenPlan?.partialAmounts.length
                : 0
              : '-'}
          </H4>
        </div> */}
        <div className="CourseShop__item">
          <H4>Precio</H4>
          <H4 fontWeight="600">
            {chosenPlan?.amount
              ? chosenPlan.amount +
                " " +
                `${chosenPlan.currency === "BOB" ? "Bs." : chosenPlan.currency}`
              : "-"}
          </H4>

          {program.codeAffiliate && <H4>Codigo Afiliado</H4>}
          <H4 fontWeight="600">
            {program.codeAffiliate ? program.codeAffiliate : ""}
          </H4>
      
        </div>
        <IconAction onClick={handleRemove} />
      </div>
      <br />
    </div>
  );
}
const RenderCoupon = (props) => {
  const { shopping, openSnackbar, sethandleCoupon } = props;
  const [load, setload] = useState(true);
  async function onSubmit(values) {
    setload(false);
    await putAction(`/order/validateCoupon`, {
      Orders: shopping.map((item) => {
        return { ProgramManagerId: item.programManagerId };
      }),
      CouponCode: values.CouponCode,
    }).then((response) => {
      if (validateStatus(response.status)) {
        sethandleCoupon(response.data);
        openSnackbar("Cupón valido", true, true);
      } else {
        openSnackbar("Cupón invalido", true, false);
      }
    });
    setload(true);
  }
  return (
    <>
      <GlobalForm
        load={load}
        textBtn="Adicionar cupón"
        onSubmit={onSubmit}
        InputsJson={InputsCoupon}
        data={{}}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    sesionUser: state.sesionUser,
  };
};
export default connect(mapStateToProps, {
  changeInfo,
  changeLayout,
  openSnackbar,
  startSession,
  changeModal,
})(Shopping);
